import React, { Component } from 'react';
import { connect } from 'react-redux';

import config from '../../config';
import { fetchJson } from '../Helpers/Helpers';

import NameCard from '../NameCard/NameCard';
import Remarks from '../Remarks/Remarks';

import CloseIcon from '@mui/icons-material/Close';

import './OverviewCard.css';

import { Card, Button, IconButton } from '@mui/material';

class OverviewCard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			expanded: false,
			hasBuildingData: false,
			building: {
				building: {},
				contacts: []
			}
		}
	}
	componentDidMount() {
		this._mounted = true;
	}
	componentWillUnmount() {
		this._mounted = false;
	}
	toggleDetails() {
		this.setState({expanded: !this.state.expanded})
		this.setBuildingInfo();
	}
	setBuildingInfo() {
		if (!this.state.hasBuildingData && this.props.id) {
			fetchJson(`buildings/${this.props.id}`).then((json) => {
				if (!json.error) {
					if (this._mounted) {
						this.setState({ building: json.data }, () => this.setState({hasBuildingData: true}));
					}
				}
			});
		}
	}

	render() {
		const map = (building, address) => {
			const marker = encodeURIComponent(`${address}`);
			const key = config.gmaps.key ? `&key=${config.gmaps.key}` : '';

			return (
				<div
					className="overview-card-map"
					style={{backgroundImage: `url(https://maps.googleapis.com/maps/api/staticmap?center=${marker}&zoom=15&size=640x150&scale=2${key})`}}
				>
					<div className="overview-card-map-card">
						<h3 title={building.building_name}>{building.building_name}</h3>
						<p>{building.building_zipcode}, {building.building_city}</p>
						<a href={`https://www.google.nl/maps/place/${marker}/`} target="_blank" rel="noopener noreferrer">{this.props.t.overview_card_view_map}</a>
					</div>
				</div>
			);
		}

		const contactCards = (contacts) => {
			return contacts.map((contact, index) => {
				// Use index to make key unique; same contact might be rendered multiple times
				return (
					<NameCard
						key={`${contact.contact_fullname || contact.employee_fullname}_${index}`}
						fullname={contact.contact_fullname || contact.employee_fullname}
						title={contact.contact_function || contact.employee_function}
						phone={contact.contact_phone_mobile || contact.employee_phone_mobile}
						phone2={contact.contact_phone || contact.employee_phone}
					/>
				);
			});
		};

		const { expanded, building, hasBuildingData } = this.state
		const { title, subtitle, numInspection, executedInspection } = this.props

		return (
			<Card className={`overview-card ${expanded ? 'overview-card-open' : ''}`}>
				<div className="overview-card-header" onClick={this.toggleDetails.bind(this)}>
					<div className="overview-card-title">
						<h3>{title}</h3>
						<h4>{subtitle}</h4>
					</div>
					<div className="overview-card-actions">
						<Button
							style={{ backgroundColor: 'transparent' }}
							onClick={this.toggleDetails.bind(this)}
							hidden={expanded}
							className="overview-card-actions-open"
							color="primary"
						>
							{
								executedInspection <= numInspection && (
									<span className={`overview-card-task-indication ${executedInspection === numInspection ? 'overview-card-task--completed' : ''}`}>
										{`${executedInspection} / ${numInspection} ${this.props.t.overview_card_inspections}`}
									</span>
								)
							}
						</Button>

						<IconButton
							onClick={this.toggleDetails.bind(this)}
							hidden={!expanded}
							className="overview-card-actions-close"
							size="large">
							<CloseIcon color="inherit" />
						</IconButton>
					</div>
				</div>

				{expanded && (
					<div className="overview-card-details">
						{this.props.children}
						<section hidden={!hasBuildingData}>
							<h4>{this.props.t.overview_building_notes}</h4>
							<Remarks
								endpoint={`buildings/${this.props.id}/remarks`}
								remarks={building.remark_text}
							/>
						</section>

						<section hidden={!building.building.building_zipcode}>
							<h4>{this.props.t.address}</h4>
							{map(building.building, subtitle)}
						</section>

						<section hidden={!building.contacts.length}>
							<h4>{this.props.t.contacts}</h4>
							<div className="overview-card-details-contacts">
								{contactCards(building.contacts)}
							</div>
						</section>
					</div>
				)}
			</Card>
		);
	}
}
function mapStateToProps (state) {
	const { t } = state.store
	return { t }
}
export default connect(mapStateToProps)(OverviewCard)

